module.exports = __webpack_public_path__ + "static/img/msg-box-success.8fa899c4.svg";